export class Command {
    public InstanceGUID: string = "";
    public GatewayName: string = "";
    public Address: string = "";
    public AddressName: string = "";
    public Command: string = "";
    public Value: string = "";
    public Timing: number = 0;
}